import { render } from "./Create.vue?vue&type=template&id=10442290"
import script from "./Create.vue?vue&type=script&setup=true&lang=js"
export * from "./Create.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AssetGroups/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10442290"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10442290', __exports__)) {
    console.log('reload')
    api.reload('10442290', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=10442290", () => {
    console.log('re-render')
    api.rerender('10442290', render)
  })

}


export default __exports__